import {PromotionTracker} from '@aboutyou/grpc-clients/tadarida/aysa_api/features/tracker/v1/tracker.types';
import {TrackingPromotionCreative} from '@aboutyou/legacy-tracking-sdk';
import React from 'react';
import {TrackPromotions} from './TrackPromotions';

interface TrackImageTeaserProps {
  promotionTrackingData?: PromotionTracker;
  promoPath: string;
  streamPosition: number;
}

export const TrackImageTeaser = ({
  children,
  promotionTrackingData,
  promoPath,
  streamPosition,
}: React.PropsWithChildren<TrackImageTeaserProps>) => {
  const promoId = promotionTrackingData?.promotionId ?? '';
  const promoName = promotionTrackingData?.promotionName ?? '';

  if (!promoId && !promoName) {
    // Not all Teasers have a promotionTrackingData, for example "SportsActivities"
    // These are merely categories displayed fancier than category-links
    return <>{children}</>;
  }

  return (
    <TrackPromotions
      promotion={{
        source: TrackingPromotionCreative.BasFlyoutTeaser,
        advertisement: {
          id: promoId,
          name: promoName,
          path: promoPath,
          creativeName: promotionTrackingData?.creativeName,
          locationId: promotionTrackingData?.locationId,
        },
      }}
      streamPosition={streamPosition}
      triggerOnce
    >
      {children}
    </TrackPromotions>
  );
};
